import React, { useState, useContext, useEffect } from "react";
import { Button, InputGroup, Tooltip, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ManagePlanLayout,
  CsplTable as Table,
  AddPlans,
  LoaderWrapper,
  SliderPanel,
  FormControlSearch,
  GetInitials,
  AddToolTip,
  SearchComponent,
} from "../../../components";
import { isEmpty, get } from "lodash";
import {
  getPathWithParam,
  getAdvancedPathWithParam,
  MANAGE_PLAN_ROUTES,
  FLOW_TYPES,
  MANAGE_MASTERS_ROUTES,
} from "../../../utils";
import { createPlanStore } from "../../../contexts";
import { useRequest, useDeepEffect } from "../../../abstracts";
import {
  getAdvisorOrganisation,
  getAllAdvisors,
  getPlansWithAdvisorRepresentative,
  UpsertAdvisorRepresentativeToPlan,
  // UpsertPlanWithClearingPartner,
  // GetPlanTradingPartnerList,
} from "../../../services";
import AdvisorCard from "./AdvisorCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBadgeCheck } from "@fortawesome/pro-solid-svg-icons";
import { faCircle } from "@fortawesome/pro-light-svg-icons";
const recordsToDisplay = [
  {
    id: 1,
    clearingPartnerName: "Arise States",
    assosiatedPlans: 20,
  },
  {
    id: 2,
    clearingPartnerName: "BN States",
    assosiatedPlans: 25,
  },
  {
    id: 3,
    clearingPartnerName: "AK Computers",
    assosiatedPlans: 15,
  },
  {
    id: 4,
    clearingPartnerName: "UMA engitech",
    assosiatedPlans: 30,
  },
  {
    id: 5,
    clearingPartnerName: "VAR",
    assosiatedPlans: 10,
  },
  {
    id: 6,
    clearingPartnerName: "JS Morgan Chase",
    assosiatedPlans: 12,
  },
  {
    id: 7,
    clearingPartnerName: "Paribas",
    assosiatedPlans: 10,
  },
];
const columns = [
  {
    id: "advisorName",
    label: "Advisor Name",
    style: { paddingLeft: "20px", fontSize: "14px", width: "60%" },
    className: "grey-text font-weight-700",
    styleName: "trade-flex-column w-60",
  },
  {
    id: "advisorNumber",
    label: "Advisor Number",
    style: { fontSize: "14px", width: "40%", paddingLeft: "10px" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-40",
  },
];
const clearingPartnerRecords = [
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
];
const AdvisorContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const [advisorRepresentativeId, setadvisorRepresentativeId] = useState(0);
  const [advisorRepresentativeDetails, setadvisorRepresentatives] = useState(
    []
  );

  const [advisorRepresentativeIds, setadvisorRepresentativeIds] = useState([]);
  const [
    planadvisorRepresentativeDetails,
    setPlanadvisorRepresentativeDetails,
  ] = useState([]);
  const [open, setOpen] = useState(false);
  const [
    defaultadvisorRepresentative,
    setDefaultadvisorRepresentative,
  ] = useState(0);
  const [editDefaultSlider, setEditDefaultSlider] = useState(false);
  const [allAdvisorRepresentatives, setAllAdvisorRepresentatives] = useState(
    []
  );
  const [
    advisorRepresentativeAccounts,
    setadvisorRepresentativeAccounts,
  ] = useState([]);
  console.log(
    "clearingPartnerDetails",
    // advisorRepresentativeIds,
    // defaultadvisorRepresentative,
    // advisorRepresentativeDetails,
    advisorRepresentativeAccounts,
    allAdvisorRepresentatives
    // planadvisorRepresentativeDetails
  );

  useDeepEffect(() => {
    if (get(state, "planId")) {
      getPlansWithAdvisorRepresentative(get(state, "planId")).then((res) => {
        if (res) {
          setPlanadvisorRepresentativeDetails(
            get(res, "planAdvisorRepresentatives", [])
          );
          setadvisorRepresentativeIds(
            get(res, "planAdvisorRepresentatives", [])?.map((e) => e.id)
          );
          // console.log("hit")
          // setDefaultClearingPartner((planClearingPartnerDetails.find(e => e.isDefault))?.id);
        }
      });
    }
  }, [state, open, editDefaultSlider]);
  useDeepEffect(() => {
    if (!isEmpty(planadvisorRepresentativeDetails)) {
      setDefaultadvisorRepresentative(
        planadvisorRepresentativeDetails.find((e) => e.isDefault)?.id
      );
    }
  }, [planadvisorRepresentativeDetails]);
  useDeepEffect(() => {
    getAllAdvisors().then((res) => {
      if (res.isSuccessful) {
        setadvisorRepresentatives(get(res, "advisors", []));
      }
    });
  }, [open]);
  useDeepEffect(() => {
    if (planadvisorRepresentativeDetails)
      setadvisorRepresentativeId(advisorRepresentativeDetails[0]?.id ?? 0);
  }, [advisorRepresentativeDetails]);
  useEffect(() => {
    if (advisorRepresentativeId) {
      getAdvisorOrganisation(advisorRepresentativeId)
        .then((res) => {
          setAllAdvisorRepresentatives(
            get(res, "advisor.advisorRepresentatives", [])
          );
          setadvisorRepresentativeAccounts(
            get(res, "advisor.advisorRepresentatives", [])
          );
        })
        .catch((err) => {});
    }
  }, [advisorRepresentativeId]);

  const onClearingPartnerClick = (id) => {
    setadvisorRepresentativeId(id);
  };

  const onAddClick = () => {
    setOpen(!open);
  };
  const searchTextBox = (val) => {
    setadvisorRepresentativeAccounts(
      allAdvisorRepresentatives?.filter(
        (e) => e.name.includes(val) || e.number.includes(val)
      )
    );
  };
  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      onClick: onAddClick,
    },
  ];
  const onCancelClick = () => {
    setOpen(!open);
  };
  const onAddPlanClick = () => {
    const payload = {
      planId: parseInt(get(state, "planId", 0)),
      advisorRepresentativeIds: advisorRepresentativeIds,
      defaultAdvisorRepresentativeId: defaultadvisorRepresentative
        ? defaultadvisorRepresentative
        : advisorRepresentativeIds[0],
    };
    UpsertAdvisorRepresentativeToPlan(payload)
      .then((res) => {
        setOpen(false);
        setEditDefaultSlider(false);
      })
      .catch((err) => {});
  };
  const editDefault = () => {
    setEditDefaultSlider(!editDefaultSlider);
  };
  const rightClearingPartnerCard = (details) => {
    const { advisorLogo, advisorFirmName, assosiatedPlans } = details;

    return (
      <>
        <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
          {!isEmpty(advisorLogo) ? (
            <img
              alt=""
              src={advisorLogo}
              style={{ width: "90px", height: "74px" }}
              className="img-fluid"
            />
          ) : (
            <GetInitials name={advisorFirmName} />
          )}
        </div>

        <div className="clearing-partner-description-box">
          <AddToolTip
            name={advisorFirmName}
            className="ft-14 font-weight-500 pb-3 clearing-partner-name"
          />
          <div className="clearing-partner-associated-plans">
            {assosiatedPlans} Associated Plans
          </div>
        </div>
      </>
    );
  };

  const TableContent = {
    advisorName: (a) => {
      console.log(a, "a");
      const addClearingPartners = (id) => {
        setadvisorRepresentativeIds([...advisorRepresentativeIds, id]);
      };
      const removeClearingPartners = (id) => {
        const filtered = advisorRepresentativeIds.filter((item) => item !== id);
        setadvisorRepresentativeIds(filtered);
        console.log(defaultadvisorRepresentative === id, "removed");
        defaultadvisorRepresentative === id &&
          setDefaultadvisorRepresentative(0);
      };
      return (
        <div className={a.styleName}>
          {advisorRepresentativeIds?.includes(a.id) ? (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="mr-2 primary-small"
              style={{ cursor: "pointer" }}
              onClick={() => removeClearingPartners(a.id)}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircle}
              className="mr-2"
              color="#7C7C80"
              onClick={() => addClearingPartners(a.id)}
              style={{ cursor: "pointer" }}
            />
          )}

          <div className="clearing-partner-id-text">
            <div className="transaction-card-top-row">{a.name}</div>
          </div>
        </div>
      );
    },
    advisorNumber: (a) => {
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{a.number}</div>
        </div>
      );
    },
    default: (a) => null,
  };
  const isLoading = !isEmpty(advisorRepresentativeAccounts);
  console.log(planadvisorRepresentativeDetails, "clearingPartnerAccounts");
  return (
    <LoaderWrapper isLoading={false}>
      <ManagePlanLayout buttons={buttons}>
        {isEmpty(planadvisorRepresentativeDetails) ? (
          <AddPlans
            menu="plan"
            subMenu="advisor"
            content={
              <>
                No Advisor Representative have been
                <br />
                added for this plan.
              </>
            }
            buttonLabel="Add Advisor Representative"
            onPrimaryClick={onAddClick}
          />
        ) : (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading">
                Advisor Representative Information
              </div>
              <div
                className="edit-button-clearing-Partner"
                onClick={editDefault}
              >
                Edit Default Account
              </div>
            </div>
            {planadvisorRepresentativeDetails?.map((e, i) => {
              return (
                <div className="clearing-partner-added-cards">
                  <div className="left-component-clearing-partner">
                    <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                      {!isEmpty(e.logo) ? (
                        <img
                          alt=""
                          src={e.logo}
                          style={{ width: "90px", height: "74px" }}
                          className="img-fluid"
                        />
                      ) : (
                        <GetInitials name={e.firmName} />
                      )}
                    </div>

                    <div className="clearing-partner-description-box">
                      <AddToolTip
                        name={e.firmName}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.associatedPlansCount ?? 0} Associated Plans
                      </div>
                      {e.isDefault && (
                        <div className="clearing-partner-associated-plans">
                          <FontAwesomeIcon icon={faBadgeCheck} /> Default
                          Account
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="right-component-clearing-partner">
                    <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                      Advisor Representative Details
                    </div>
                    <AddToolTip
                      name={e.representativeName}
                      className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                    />
                    <div className="clearing-partner-associated-plans">
                      {e.number}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <SliderPanel
          isOpen={editDefaultSlider}
          size="50"
          onClose={editDefault}
          showCancel={false}
        >
          <div className="clearing-partner-inside-content">
            <div className="d-flex justify-content-between align-baseline">
              <div>
                <p className="investment-heading">Edit Default Account</p>
              </div>
              <div>
                <Button variant="secondary" onClick={editDefault}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={onAddPlanClick}
                  className="ml-4"
                >
                  Set As Default Account
                </Button>
              </div>
            </div>
            {!isEmpty(planadvisorRepresentativeDetails) &&
              planadvisorRepresentativeDetails.map((e, i) => {
                return (
                  <div className="clearing-partner-added-cards">
                    <div className="left-component-clearing-partner">
                      <Form.Check // prettier-ignore
                        type={"radio"}
                        name="group1"
                        value={e.id}
                        id={`default-radio-${i}`}
                        onChange={(e) =>
                          setDefaultadvisorRepresentative(
                            parseInt(e.target.value)
                          )
                        }
                      />

                      <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                        {!isEmpty(e.logo) ? (
                          <img
                            alt=""
                            src={e.logo}
                            style={{ width: "90px", height: "74px" }}
                            className="img-fluid"
                          />
                        ) : (
                          <GetInitials name={e.firmName} />
                        )}
                      </div>

                      <div className="clearing-partner-description-box">
                        <AddToolTip
                          name={e.firmName}
                          className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                        />
                        <div className="clearing-partner-associated-plans">
                          {e.totalPlans} Associated Plans
                        </div>
                      </div>
                    </div>
                    <div className="right-component-investment-clearing-partner">
                      <div className="inner-bank-details">
                        <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                          Advisor Representative Details
                        </div>
                        <AddToolTip
                          name={e.representativeName}
                          className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                        />
                        <div className="clearing-partner-associated-plans">
                          {e.number}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </SliderPanel>
        <SliderPanel
          isOpen={open}
          size="50"
          onClose={() => onCancelClick()}
          showCancel={false}
        >
          <div className="clearing-partner-inside-content">
            <div className="d-flex justify-content-between align-baseline">
              <div>
                <p className="investment-heading">Add Advisor Representative</p>
              </div>
              <div>
                <Button variant="secondary" onClick={onCancelClick}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={onAddPlanClick}
                  className="ml-4"
                >
                  Add To Plan
                </Button>
              </div>
            </div>
            <div className="clearing-partners-list-container">
              <div className="clearing-partners-list">
                {advisorRepresentativeDetails?.map((item, index) => {
                  return (
                    <AdvisorCard {...item} onSelect={onClearingPartnerClick} />
                  );
                })}
              </div>
              <div className="clearing-partners-list-item">
                <p className="investment-heading">Advisor Representatives</p>
                <div className="search-bar-clearing-partner">
                  <SearchComponent
                    placeholder="Search by Advisor Representative Name, Number"
                    className="search-component-clearing-partner"
                    onSearchChange={searchTextBox}
                  />
                </div>
                <div className="clearing-partner-added-container">
                  <div className="clearing-partner-subjects">
                    <div className="clearing-partner-recently-added">
                      Recently Added/Modified
                    </div>
                    <div className="clearing-partner-records">
                      {advisorRepresentativeAccounts.length ?? 0} Records found
                    </div>
                  </div>
                  <Link
                    className="create-partner-id"
                    to={`${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS}/${advisorRepresentativeId}`}
                  >
                    + Create Partner ID
                  </Link>
                </div>
                <div className="clearing-partner-card-list">
                  <div className="column-filters-clearing-partner">
                    {columns.map((_) => (
                      <div className={_.className} style={{ ..._.style }}>
                        {" "}
                        {_.label}
                      </div>
                    ))}
                  </div>
                  {/* <LoaderWrapper isLoading={isLoading}> */}
                  {!isEmpty(advisorRepresentativeAccounts) &&
                    advisorRepresentativeAccounts?.map((e, i) => {
                      return (
                        <div className="clearing-partner-list-table-component trade-transaction-card">
                          {columns.map((a, b) => {
                            // console.log(a, "regs");
                            // const args = {...a,...e}
                            return TableContent[a.id]({ ...a, ...e });
                          })}
                        </div>
                      );
                    })}
                  {/* </LoaderWrapper> */}
                </div>
              </div>
            </div>
          </div>
        </SliderPanel>
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default AdvisorContainer;
